//import React, { useEffect } from 'react';

import ReactDOM from 'react-dom';
import { IonReactRouter } from '@ionic/react-router';
//import { Capacitor } from '@capacitor/core';
//import { Http } from '@capacitor-community/http';

import App from './App';

import { PublicMerchantID_provider } from './storeState/public_merchantID_context';
import { AuthenticatedMerchantProvider } from './storeState/auth_merchantID_context'
import { AuthenticatedClientProvider } from './storeState/auth_clientID_context'



//export const Index: React.FC = () => {
export function Index () {

    //alert('Index: React.FC');
    // useEffect(() => {
    // // Only affects native Android/iOS builds.
    // if (Capacitor.isNativePlatform()) {
    //     Http.setServerTrustMode({ mode: 'default' })
    //     .then(() => console.log('HTTP trust mode set to default'))
    //     .catch((e) => console.log('setServerTrustMode error', e));
    // }
    // }, []);

    //return   <PublicMerchantID_provider><AuthenticatedMerchantProvider><AuthenticatedClientProvider><IonReactRouter><App  /></IonReactRouter></AuthenticatedClientProvider></AuthenticatedMerchantProvider></PublicMerchantID_provider>;
    return   <AuthenticatedMerchantProvider><AuthenticatedClientProvider><IonReactRouter><App  /></IonReactRouter></AuthenticatedClientProvider></AuthenticatedMerchantProvider>;

}

ReactDOM.render(<Index />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
